export const version = "sha2/5.6.1";
//# sourceMappingURL=_version.js.map